import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next';
import CustomerSearch from '../../Components/Search/CustomerSearch'
import settingsActions from '../../Actions/settingsActions'
import routes from '../../Constants/routes'
import { useNavigate } from 'react-router-dom';

function CustomerInfoTypesContainer({ t }) {

    const navigate = useNavigate();

    const customerSearchOnChange = (customer) => {
        const customerNumber = customer?.customerNumber || customer?.customerId;
        if (customerNumber) {
            navigate(routes.settingsCustomerInfoTypeEdit(customerNumber));
        }
    }

    return (
        <div>
            <div className="form-group form-search">
                <label className="col-xs-4 control-label">{t('customerinfotypescontainer.searchcustomer')}</label>
                <CustomerSearch
                    id={"customerInfoTypesSearch"} 
                    onChange={customerSearchOnChange} 
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        settingsActions: bindActionCreators(settingsActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomerInfoTypesContainer));